import { api } from "@/services/api";
import searchUsersEndpoint from "./search-users";
import addUserEndpoint from "./add-user";
import inviteUserEndpoint from "./invite-user";
import updateUserEndpoint from "./update-user";
import updateUserStatusEndpoint from "./update-user-status";
import checkUserExists from "./check-user-exists";
import getUserByIdEndpoint from "./get-user-by-id";


export const usersApi = api.injectEndpoints({
  endpoints: build => ({
    searchUsers: searchUsersEndpoint(build),
    addUser: addUserEndpoint(build),
    inviteUser: inviteUserEndpoint(build),
    updateUser: updateUserEndpoint(build),
    updateUserStatus: updateUserStatusEndpoint(build),
    getUserById: getUserByIdEndpoint(build),
    checkUserExists : checkUserExists(build),
  }),
});

export const {
  useGetUserByIdQuery,
  useSearchUsersQuery,
  useLazySearchUsersQuery,
  useAddUserMutation,
  useInviteUserMutation,
  useUpdateUserMutation,
  useUpdateUserStatusMutation,
  useCheckUserExistsQuery,
  useLazyCheckUserExistsQuery
} = usersApi;
